// extracted by mini-css-extract-plugin
module.exports = {"page":"riverpro-firmware-update-guide_page__geVzK"};